import { createContext, useContext, type ReactNode } from "react";

// STUB — CHG-1167 scaffold. Vocabulary YAML lands α CHG-1132 (parallel sibling).
// Per feedback_stage_labels_human_readable.md raw enums in JSX are forbidden —
// this stub returns the key as the value so callsites already use t() and the
// hookup is a one-line swap when CHG-1132 ships.

export interface VocabularyContextValue {
  t: (key: string) => string;
}

const VocabularyContext = createContext<VocabularyContextValue>({
  t: (key: string) => key,
});

export function VocabularyProvider({ children }: { children: ReactNode }) {
  return (
    <VocabularyContext.Provider value={{ t: (key: string) => key }}>
      {children}
    </VocabularyContext.Provider>
  );
}

export function useVocabulary(): VocabularyContextValue {
  return useContext(VocabularyContext);
}
